import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { Dashboard } from './Dashboard';

export const DashboardResource: ResourceProps = {
  name: Resources.Dashboard,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: Dashboard,
};
